<template>
  <div class="grouped-products">
    <template v-if="loading">
      <div v-for="item in 3" :key="item" class="skeleton-item">
        <div>
          <VanSkeleton title :row="2"></VanSkeleton>
        </div>
        <div class="inner-list">
          <div v-for="it in 3" :key="it" class="inner-item">
            <VanSkeleton title :row="Number((Math.random() * 2).toFixed(0))" style="flex: 1;"></VanSkeleton>
            <VanSkeletonImage style="width: 112px; height: 32px;"></VanSkeletonImage>
            <VanSkeleton title :row="1" style="width: 200px;"></VanSkeleton>
            <VanSkeleton title :row="1" style="width: 100px;"></VanSkeleton>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-for="product in formattedProducts" :id="product.groupName" :key="product.groupId" class="group-product">
        <h2>{{ product.groupName }}</h2>
        <div class="product-items">
          <div v-for="item, index in product.showMore ? product.items : product.items?.slice(0, expandLength)" :key="item.attId" class="product-item">
            <!-- <ElTag :type="item.travellerType === 'Adult' ? 'primary' : 'warning'" effect="dark">
              {{ item.travellerType === 'Adult' ? t('key.business.select.ticket.audit') : t('key.business.select.ticket.child') }}
            </ElTag> -->
            <div class="sku-title" flex="~ col" gap="2">
              <div flex="~" items-center gap="2">
                <div>
                  <VanTag relative bottom-1px mr="1" :type="item.ageBand === 1 ? 'success' : 'warning'">
                    {{ item.ageBand === 1 ? t('key.ticket.ADULT') : t('key.ticket.CHILD') }}
                  </VanTag>
                  {{ item.showName }}
                </div>
              </div>
              <div v-if="item.tags.length">
                <VanTag
                  v-for="it in item.tags"
                  :key="it"
                  type="success"
                  plain
                >
                  {{ it }}
                </VanTag>
              </div>
            </div>
            <img :src="item.logoUrl" alt="">
            <div class="price-and-desc">
              <div class="price">
                {{ getPrice(item) }}
              </div>
              <div class="desc">
                {{ item.cashbackDesc }}
              </div>
            </div>
            <div relative>
              <div class="azgo-haptics-feedback azgo-button-feedback" min-w="42" px="4" h="13" flex="~ items-center justify-center" rounded="2" text="lg white" font="500" @click="clickViewDeal(product, index)">
                {{ getViewButtonText(item) }}
                <NuxtIcon name="my-icon:jump" class="ml-2" text="xs white" />
              </div>
              <div v-if="item.bookingDirect" absolute right="-3" top="-3" bg="red" rounded="50%" w="6" h="6" flex="~" items="center" justify="center">
                <VanIcon name="good-job" text="white" :size="16" />
              </div>
            </div>
          </div>
          <div v-if="product.needExpand" class="expand-operate">
            <div @click="showAllOrLess(product)">
              <template v-if="product.showMore">
                {{ t('key.attraction.detail.price.lessOptions') }}
                <ElIcon><ElIconArrowUp></ElIconArrowUp></ElIcon>
              </template>
              <template v-else>
                {{ getExpandWord(product) }}
                <ElIcon><ElIconArrowDown></ElIconArrowDown></ElIcon>
              </template>
            </div>
          </div>
        </div>
      </div>
      <Empty v-if="!formattedProducts.length" :show-btn="false" desc=""></Empty>
    </template>
  </div>
</template>

<script lang="ts" setup>
const { t } = useI18n()
const {
  formattedProducts,
  expandLength,
  loading,
  getViewButtonText,
  getExpandWord,
  clickViewDeal,
  getPrice,
  showAllOrLess,
} = useAttractionDetail()
</script>

<style lang="scss" scoped>
$border-radius: 24px;

.grouped-products {
  margin: 10px 0 20px 0;
  .group-product {
    padding: 0 10px 10px 10px;
    margin-bottom: 20px;
    border-radius: $border-radius;
    background-color: #ECF3FC;
  }
  h2 {
    padding-left: 24px;
    font-size: 20px;
    font-weight: 600;
    line-height: 72px;
    height: 72px;
  }
  .product-items {
    border-radius: $border-radius;
    background-color: #FFFFFF;
    .product-item {
      display: flex;
      align-items: center;
      padding: 18px 24px;
      gap: 40px;
      .sku-title {
        flex: 1;
        font-size: 16px;
        font-weight: 300;
        line-height: 20px;
      }
      .price-and-desc {
        display: flex;
        flex-direction: column;
        width: 160px;
        .price {
          font-size: 22px;
          font-weight: 600;
          line-height: 32.5px;
        }
        .desc {
          color: var(--tc-color-cashback-desc);
        }
      }
      >img {
        width: 100px;
      }
      .operate-button {
        height: 54px;
        width: 200px;
        font-size: 18px;
        border-radius: 10px;
      }
      &:not(:last-child) {
        border-bottom: 2px solid #ECF3FC;
      }
    }
  }
  .expand-operate {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    font-size: 16px;
    color: var(--tc-color-primary);
    > div {
      display: flex;
      align-items: center;
      gap: 4px;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
.skeleton-item {
  padding: 0 10px 10px 10px;
  margin-bottom: 20px;
  border-radius: $border-radius;
  background-color: #ECF3FC;
  .inner-list {
    border-radius: $border-radius;
    background-color: #FFFFFF;
  }
  .inner-item {
    padding: 18px 24px;
    display: flex;
    align-items: center;
    border-bottom: 2px solid #ECF3FC;;
  }
}
</style>
